import React from "react";
import SolidosTable from "./SolidosTable/SolidosTable";
import LatexProcesoTable from "./LatexProcesoTable/LatexProcesoTable";
import SKIMTable from "./SKIMTable/SKIMTable";

export default function ComparativoCostoVentas() {
    return (
        <div className="report__container">
            <SolidosTable />
            <LatexProcesoTable />
            <SKIMTable />
        </div>
    );
}
